export default "__VITE_ASSET__ab4224bf__"